<template>
  <!-- Modal container -->
  <div
    class="fixed inset-0 flex items-center justify-center z-50"
    v-show="showModal"
    @click.self="closeModal"
  >
    <!-- Close button -->
    <button
      class="modal-close absolute top-0 right-0 pt-2 pr-4 z-50"
      @click="closeModal"
    >
      <svg
        class="fill-current text-white h-8 w-8"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M14.35 14.35a1 1 0 0 1-1.41 0L10 11.41l-2.94 2.94a1 1 0 1 1-1.41-1.41L8.59 10 5.65 7.06a1 1 0 0 1 0-1.41 1 1 0 0 1 1.41 0L10 8.59l2.94-2.94a1 1 0 0 1 1.41 1.41L11.41 10l2.94 2.94a1 1 0 0 1 0 1.41z"
        />
      </svg>
    </button>
    <!-- Modal overlay -->
    <div class="modal-overlay fixed inset-0 bg-black opacity-50"></div>

    <!-- Modal content -->
    <div
      class="modal-container bg-white w-11/12 md:max-w-2xl mx-auto rounded shadow-lg z-50 overflow-y-auto"
    >
      <!-- YouTube video -->
      <div class="modal-content py-6 text-left px-5">
        <h3 class="text-lg font-bold mb-0">Welcome to ScreenLab</h3>
        <p class="mb-4 mt-0 text-sm">
          This walkthrough video will help you get started with the platform:
        </p>
        <!-- Embed responsive YouTube video -->
        <div class="embed-responsive">
          <iframe
            class="youtube-video"
            :src="youtubeEmbedUrl"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
        <!-- don't show again checkbox -->
        <div class="mt-4 flex">
          <input
            type="checkbox"
            id="dontShowAgain"
            name="dontShowAgain"
            class="mr-1"
            v-model="dontShowAgain"
          />
          <label for="dontShowAgain">Don't show this again</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";

export default {
  data() {
    return {
      user: null,
      showModal: false,
      dontShowAgain: false,
      youtubeVideoId: "drUrLT0PS38",
    };
  },
  computed: {
    youtubeEmbedUrl() {
      return `https://www.youtube.com/embed/${this.youtubeVideoId}`;
    },
  },
  methods: {
    openModal() {
      this.showModal = true;
      // Prevent scrolling of background content when modal is open
      document.body.classList.add("overflow-hidden");
    },
    closeModal() {
      this.showModal = false;
      // Allow scrolling of background content when modal is closed
      document.body.classList.remove("overflow-hidden");
    },
  },
  watch: {
    async dontShowAgain() {
      // if user checks the "don't show again" checkbox
      // update user attributes
      if (this.dontShowAgain) {
        await Auth.updateUserAttributes(this.user, {
          "custom:hasSeenWalkthrough": "true",
        });
      }
    },
  },
  async mounted() {
    this.user = await Auth.currentAuthenticatedUser({ bypassCache: true });
    // check if user has seen walkthrough video
    // if not, show modal
    if (this.user.attributes["custom:hasSeenWalkthrough"] != "true") {
      this.openModal();
    }
  },
};
</script>

<style scoped>
/* Add Tailwind CSS classes as needed for styling */
.youtube-video {
  aspect-ratio: 16 / 9;
  width: 100%;
}
</style>
